var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-manager"},[(_vm.delegatesLoaded)?_c('card-form'):_vm._e(),_vm._v(" "),(_vm.loadingDelegates)?_c('span',[_vm._v("Loading delegates...")]):_vm._e(),_vm._v(" "),(_vm.loadingMotions)?_c('span',[_vm._v("Loading motions...")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90899658","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/CardsManager.vue
// module id = null
// module chunks = 